<template>
<div class="container">
  <div class="my-64 p-24 bg-white border border-grey-lighter rounded shadow fixed-page-height">
    <!-- <template v-if="title">
      <h1 class="font-bold text-center">{{ title }}</h1>
    </template> -->
    <template v-if="src">
      <!-- <pdf v-for="i in totalPages" :src="src" :key="i" :page="i"></pdf> -->
      <vue-pdf-embed :source="src" />
    </template>
  </div>
</div>
</template>

<script>
// import crypto from '@/utils/crypto'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
export default {
  name: 'PdfViewer',
  props: {
    data: {
      type: String
    }
  },
  components: {
    VuePdfEmbed
  },
  data () {
    return {
      // pageInfo: crypto.decode(this.data),
      // title: null,
      // totalPages: null,
      src: process.env.VUE_APP_GIFT_RULES_URL
    }
  },
  methods: {
  },
  mounted () {
    // this.src = pdf.createLoadingTask(this.pageInfo)
    // this.title = this.$t('nightToCoupon.detailRule') || this.pageInfo.title
    // this.src.promise.then(pdf => {
    //   this.totalPages = pdf.numPages
    // })
  }
}
</script>

<style lang="sass" scoped>
  .fixed-page-height
    min-height: 80vh
</style>
